import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const categorySchema = z.object({
  id: z.number(),
  org: z.number(),
  category_path: z.string().nullable(),
  category_path_channel_id: z.string().nullable(),
  channel: z.string(),
  leaf_category_channel_id: z.number().nullable(),
  leaf_category_name: z.string(),
  market_place: z.string(),
  ad_count: z.number(),
  product_count: z.number(),
  search_rank: z.number(),
});
export type Category = z.infer<typeof categorySchema>;

export const gvadsApiDefinitions = prefixApi(
  "/gvads",
  apiBuilder({
    alias: "getCategories",
    method: "get",
    path: "/categories",
    parameters: [
      {
        name: "marketplace",
        type: "Query",
        schema: z.string(),
      },
      {
        name: "channel",
        type: "Query",
        schema: z.string(),
      },
    ],
    status: 200,
    response: categorySchema.passthrough().array(),
  }).build(),
);
